import { useAppSelector } from '../../../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../../store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getMandantsSelector } from '../../../../../store/selectors/get-mandants/get-mandants.selector';
import { MandantConfigModel } from './models/mandant-config.model';
import { findMandantPredicate } from './utils/find-mandant-predicate/find-mandant-predicate.util';

export const useGetMandantConfig = (): MandantConfigModel => {
  const mandants = useAppSelector(getMandantsSelector);
  const activeMandantId = useAppSelector(getActiveMandantIdSelector);
  const selectedMandant = mandants?.find(findMandantPredicate(activeMandantId));
  const mainLogo = selectedMandant?.logo;
  return { mandants, activeMandantId, selectedMandant, mainLogo };
};
